import React, { Component } from 'react';
import { SingleDatePicker } from 'react-dates';

import { translate } from 'components/translate';
import DateHelper from 'helpers/Date';
import moment from 'moment';
import PropTypes from 'prop-types';
import 'react-dates/initialize';

import './DatePicker.scss';

@translate()
export default class DatePicker extends Component {
  static propTypes = {
    date: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.object,
      PropTypes.string
    ]),
    isOutsideRange: PropTypes.func,
    onDateChange: PropTypes.func,
    disabled: PropTypes.bool,
    t: PropTypes.func,
    onFocus: PropTypes.func,
    showClearDate: PropTypes.bool,
    isLiveForm: PropTypes.bool
  };

  static defaultProps = {
    disabled: false,
    showClearDate: true,
    isLiveForm: false
  };

  constructor(props) {
    super(props);

    const date = props.date ? moment.utc(props.date) : null;

    this.state = {
      focused: false,
      date
    };

    moment.locale(DateHelper.language);
  }

  normalizedDate(date) {
    const { isLiveForm } = this.props;

    if (isLiveForm) {
      return moment(date);
    }

    if (!moment.isMoment(date) || !date.isUTC()) {
      date = moment.utc(date);
    }

    // Remove the time portion as performed in backend to avoid differences in dirty state check
    // (https://stackoverflow.com/questions/15130735/how-can-i-remove-time-from-date-with-moment-js)
    date = date.startOf('day');

    return date;
  }

  componentDidUpdate(prevPros) {
    if (prevPros.date !== this.props.date) {
      const date = this.props.date
        ? this.normalizedDate(this.props.date)
        : null;

      this.setState({ date });
    }
  }

  onDateChange = (value) => {
    const date = value;

    this.props.onDateChange && this.props.onDateChange(date && date.valueOf());
  };

  handleFocusChange = ({ focused }) => {
    const { onFocus } = this.props;

    focused && onFocus && onFocus();
    this.setState({ focused });
  };

  render() {
    const { date, focused } = this.state;
    const {
      disabled,
      isOutsideRange,
      t,
      showClearDate,
      id = 'drippingDate'
    } = this.props;

    return (
      <SingleDatePicker
        customInputIcon={<i className="icon icon-calendar" />}
        date={date}
        focused={focused}
        hideKeyboardShortcutsPanel={true}
        id={id}
        inputIconPosition="after"
        numberOfMonths={1}
        onDateChange={this.onDateChange.bind(this)}
        onFocusChange={this.handleFocusChange}
        placeholder={t('general.date')}
        withPortal={true}
        readOnly={true}
        showClearDate={true}
        disabled={disabled}
        isOutsideRange={isOutsideRange}
        {...(!showClearDate && { customCloseIcon: () => null })}
      />
    );
  }
}
